import { createApp } from 'vue'
import App from './App.vue'
import './assets/massdata-styles.css'
import './assets/hacker-theme.css'

createApp(App).mount('#app')
